import { filter, map } from 'ramda'
import { ATTRIBUTE_STATUS } from '../components/Settings/PropertyLists/constants'

export const filterDriftProperties = (propertyList, selectedFieldsInSettings, reservedFields, systemAttributes, sourcedAttributes, sfdcProperties) => {
  const separatedProperties = {}

  const applyEnabledFields = mapEnabledFieldsWith(selectedFieldsInSettings)

  const driftProperties = map(
    (driftProp) => mapWithType(driftProp, 'drift'),
    filter(property => reservedFields.includes(property.name), propertyList)
  )

  const customProperties = map(
    (customProp) => mapWithType(customProp, 'custom'),
    filter(property => !reservedFields.includes(property.name) && !systemAttributes.includes(property.name) && !sourcedAttributes.includes(property.name) && property.status === "ENABLED", propertyList)
  )

  const archivedProperties = map(
    (archivedProp) => mapWithType(archivedProp, 'archived'),
    filter(property => property.status === ATTRIBUTE_STATUS.ARCHIVED, propertyList)
  )

  const sourcedProperties = map(
    (sourcedProp) => mapWithType(sourcedProp, 'sourced'),
    filter(property => !reservedFields.includes(property.displayName) && !systemAttributes.includes(property.displayName), sourcedAttributes)
  )

  const salesforceProperties = map(
    (property) => mapWithTypeAndSource(property, property.endUserPropertySource, property.endUserPropertySource), sfdcProperties
  )
  const preppedSourcedProps = applyEnabledFields(sourcedProperties, 'displayName')
  const preppedDriftProps = applyEnabledFields(driftProperties)
  const preppedCustomProps = applyEnabledFields(customProperties)
  const preppedArchivedProps = applyEnabledFields(archivedProperties)

  const preppedSalesforceProperties = applyEnabledFields(salesforceProperties)

  separatedProperties.drift = preppedDriftProps
  separatedProperties.custom = preppedCustomProps
  separatedProperties.archived = preppedArchivedProps
  separatedProperties.sourced = preppedSourcedProps
  separatedProperties.sfdc = preppedSalesforceProperties
  
  return separatedProperties
}

const mapWithTypeAndSource = (prop, type, source) => {
  prop.attributeType = type
  prop.source = source
  return prop
}

const mapWithType = (prop, type) => {
  prop.attributeType = type
  return prop
}

const mapEnabledFieldsWith = enabled => (properties, key = 'name') => {
  return properties.map(property => {
    if (enabled.map(field => field.name).includes(property[key])) {
      if (property.source === "SALESFORCE_CONTACT" || property.source === "SALESFORCE_LEAD" || property.source === "SALESFORCE_ACCOUNT") {
        property.isSelected = enabled.map(field => (field.name === property[key] && field.source === property.source)).includes(true)
        return property
      }
      property.isSelected = true
    }
    return property
  })
}
